import './Footer.css';

export default function Footer() {

  return (
    <footer>
      <p><a href='https://github.com/joekgilberto/date-and-thyme' target='_blank'>date & thyme</a> is made with <a href='https://www.djangoproject.com/' target='_blank'>Django</a>, <a href='https://react.dev/' target='_blank'>React</a>, <a href='https://mui.com/material-ui/' target='_blank'>Material UI</a>, and <a href='https://www.postgresql.org/' target="_blank">PostgreSQL</a> by <a href='https://joekgilberto.com/' target='_blank'>Joe Gilberto</a>.</p>
    </footer>
  );
}